import React from "react";
import { useUserContext } from "../../contexts/UserContext"; // 🔥 Importamos el contexto
import "./AgeVerificationModal.css"; // ✅ Agregar estilos en un archivo CSS separado

const AgeVerificationModal = () => {
  const { confirmarEdad, negarAcceso } = useUserContext(); // 🔥 Obtenemos las funciones del contexto

  return (
    <div className="age-modal-overlay">
      <div className="age-modal">
        <h2> Verificación de edad</h2>
        <p>Debes ser mayor de 18 años<br/> para ingresar a nuestra tienda.</p>
        <div className="age-buttons">
          <button className="btn-yes" onClick={confirmarEdad}> Soy mayor de 18</button>
          <button className="btn-no" onClick={negarAcceso}> No, salir</button>
        </div>
      </div>
    </div>
  );
};

export default AgeVerificationModal;
